import { ReactNode, useCallback } from 'react';
import IconTick from 'assets/images/icon__tick--blue.svg';
import { Fragment } from 'react';

interface Props {
  steps: { id: number; label: string; subtitle?: string; action?: ReactNode }[];
  activeStep: number;
  vertical?: boolean;
  showLabel?: boolean;
}

export const PratusStepper = ({
  steps,
  activeStep,
  vertical = false,
  showLabel = true,
}: Props) => {
  const getStepClass = useCallback(
    (stepId: number) => {
      if (activeStep > stepId) {
        return 'completed';
      }

      if (activeStep === stepId) {
        return 'active';
      }

      return '';
    },
    [activeStep]
  );

  const getLineClass = (id: number) => {
    return activeStep >= id ? 'active' : '';
  };

  return (
    <div
      className={`steps-container ${
        vertical ? 'vertical flex-column align-items-start' : 'flex-row'
      }`}
    >
      {steps.map((step, idx) => {
        const currentStepClass = getStepClass(step.id);

        return (
          <Fragment key={step.id}>
            <div key={step.id} className={`step ` + currentStepClass}>
              <span className={`step-number ` + currentStepClass}>
                {currentStepClass !== 'completed' ? (
                  step.id
                ) : (
                  <img src={IconTick} alt="" />
                )}
              </span>
              <span className={`step-label ` + currentStepClass}>
                {showLabel && step.label}
                {showLabel && step.subtitle && (
                  <div className="step-subtitle text-muted">
                    {step.subtitle}
                  </div>
                )}
              </span>
              {step.action && step.action}
            </div>
            {idx < steps.length - 1 && (
              <div
                className={`line ${vertical && 'vertical'} ${getLineClass(step.id)}`}
              ></div>
            )}
          </Fragment>
        );
      })}
    </div>
  );
};
